import { Link } from "react-router-dom";
import { useSite } from "@/hooks/useSite";
import { LoadState } from "@/components/ErrorBoundary";
import { Seo } from "@/components/Seo";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { AlertTriangle, ArrowLeft } from "lucide-react";

const CONTENT = {
  impressum: { key: "impressum_body", title: "Impressum", desc: "Impressum und Offenlegung von ArtPart – René Ghavami, St. Ruprecht an der Raab." },
  datenschutz: { key: "datenschutz_body", title: "Datenschutzerklärung", desc: "Informationen zur Verarbeitung personenbezogener Daten auf der ArtPart-Website." },
  versand: { key: "versand_body", title: "Versand & Bestellanfrage", desc: "Informationen zu Bestellanfrage, Versand und Bezahlung von ArtPart-Artikeln." },
};

export default function LegalPage({ type }) {
  const { site, status, error, reload } = useSite();
  const meta = CONTENT[type];

  if (!site) return <LoadState status={status} error={error} onRetry={reload} label="Wird geladen" />;

  const body = site.texts[meta.key] || "";

  return (
    <>
      <Seo title={`${meta.title} – ArtPart`} description={meta.desc} path={`/${type}`} />
      <Header instagram={site.texts.instagram_url} onePage={false} />
      <main className="bg-paper pt-[72px]">
        <div className="ap-container max-w-3xl py-16 sm:py-24">
          <p className="ap-stamp">AP · RECHTLICHES</p>
          <h1 className="ap-h1 mt-4 text-ink">{meta.title}</h1>

          <div
            data-testid="legal-warning"
            className="mt-8 flex items-start gap-3 border border-signal bg-signal/5 p-4"
          >
            <AlertTriangle size={18} className="mt-0.5 shrink-0 text-signal" />
            <p className="ap-body text-charcoal">{site.texts.legal_warning}</p>
          </div>

          <div data-testid="legal-body" className="mt-10 whitespace-pre-line text-sm leading-relaxed text-ink sm:text-base">
            {body}
          </div>

          <Link to="/" className="ap-btn-ghost mt-12" data-testid="legal-back">
            <ArrowLeft size={15} /> Zurück zur Hauptseite
          </Link>
        </div>
      </main>
      <Footer texts={site.texts} />
    </>
  );
}
